import { useRouteLoaderData } from "react-router-dom";

import { ProductForm } from "@/components/ProductForm";
import { UPDATE_PRODUCT_ROUTE_ID } from "@/router";

interface ProductLoaderData {
  id?: string;
  name?: string;
  latin?: string | null;
  price?: number | null;
  unit?: string | null;
}

export function UpdateProduct(): React.JSX.Element {
  const data = useRouteLoaderData(UPDATE_PRODUCT_ROUTE_ID);

  return (
    <>
      <ProductForm {...(data as ProductLoaderData)} />
    </>
  );
}
